<template>
    <div>
        <CoreTwoColumnsRow
            v-for="(email, index) in emails"
            :key="email.index"
            class="mb-1"
        >
            <template #left>
                <CoreStringInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-30"
                    placeholder="§ui.placeholder_input_invoice_email"
                    v-model="emails[index].email"
                    :condensed="true"
                    :disabled="saving || isPlaceholder"
                    :name="`${group}-email-input`"
                    @update:modelValue="setInput(index, 'email', $event)"
                />
            </template>

            <template #right>
                <div class="flex-grow-1 flex-shrink-1 flex-basis-70">
                    <CoreTwoColumnsRow>
                        <template #left>
                            <CoreDropdown
                                class="flex-grow-1 flex-shrink-1"
                                v-model="emails[index].type"
                                :condensed="true"
                                :disabled="saving || isPlaceholder"
                                :filter="false"
                                :name="`${group}-type-input`"
                                :options="emailTypeOptions"
                                :sort="false"
                                :placeholder="$t(placeholder)"
                                :style="{
                                    'flex-basis': '36%',
                                }"
                                @update:modelValue="setInput(index, 'type', $event)"
                            />
                        </template>
                        <template #right>
                            <CoreStringInput
                                class="flex-grow-1 flex-shrink-1"
                                placeholder="§ui.placeholder_input_email_contact_person"
                                v-model="emails[index].name"
                                :condensed="true"
                                :disabled="saving || isPlaceholder"
                                :name="`${group}-person-input`"
                                :style="{
                                    'flex-basis': '64%',
                                }"
                                @update:modelValue="setInput(index, 'name', $event)"
                            />

                            <div
                                v-if="!isPlaceholder"
                                class="remove-button"
                                @click="removeEmail(index)"
                            >
                                <CoreIcon
                                    name="minus"
                                    size="20"
                                />
                            </div>
                        </template>
                    </CoreTwoColumnsRow>
                </div>
            </template>
        </CoreTwoColumnsRow>

        <CoreLinkSecondary
            v-if="!isPlaceholder"
            :text="headingText"
            @click="addNewEmail(group)"
        />
    </div>
</template>

<script>
import { useClientStore } from '@/stores/client'
import CoreIcon from '@/components/core/CoreIcon.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreLinkSecondary from '@/components/core/CoreLinkSecondary.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
export default {
    name: 'MultiEmailList',

    components: {
        CoreIcon,
        CoreStringInput,
        CoreLinkSecondary,
        CoreBorderWrapper,
        CoreTwoColumnsRow,
        CoreDropdown,
    },

    props: {
        saving: {
            type: Boolean,
            default: false,
        },
        group: {
            type: String,
            required: true,
        },
        headingText: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            clientStore: useClientStore(),

            emailTypeOptions: [
                { value: 'to', label: '§eq_operator.send_to' },
                { value: 'cc', label: '§eq_operator.send_cc' },
                { value: 'bcc', label: '§eq_operator.send_bcc' },
            ],
        }
    },

    computed: {
        isPlaceholder() {
            return !!this.clientStore.clientData.is_dummy
        },

        emails() {
            return this.clientStore.clientData[this.group]
        },
    },

    methods: {
        addNewEmail() {
            this.clientStore.clientData[this.group] = [
                ...this.emails,
                { email: '', type: 'to', name: '' },
            ]
        },

        setInput(index, name, value) {
            this.clientStore.clientData[this.group][index][name] = value

            if (name === 'email') {
                const email = value
                const currentName = this.emails[index].name

                if (!currentName && email.includes('@')) {
                    const newName = email.split('@')[0]

                    this.clientStore.clientData[this.group][index]['name'] = newName
                }
            }
        },

        setIsOpen(value) {
            if (value !== this.isOpen) {
                this.isOpen = value
            }
        },

        removeEmail(index) {
            this.clientStore.clientData[this.group] = this.emails.filter((_, i) => i !== index)
        },
    },
}
</script>

<style scoped>
.remove-button {
    cursor: pointer;

    width: 24px;
    height: 24px;
    & > span {
        width: 24px;
        height: 24px;
        border-radius: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--color-error);

        color: var(--color-white);
    }
}
</style>
